import { render, staticRenderFns } from "./policies-and-procedures.vue?vue&type=template&id=4f30d9d8&scoped=true"
import script from "./policies-and-procedures.vue?vue&type=script&lang=js"
export * from "./policies-and-procedures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f30d9d8",
  null
  
)

export default component.exports